// extracted by mini-css-extract-plugin
export default {"image_container":"styles_image_container__DSgui","image_content":"styles_image_content__8-J94"};